import { render, staticRenderFns } from "./NewBuilt.vue?vue&type=template&id=4f8eee0e&scoped=true&"
import script from "./NewBuilt.vue?vue&type=script&lang=js&"
export * from "./NewBuilt.vue?vue&type=script&lang=js&"
import style0 from "./NewBuilt.vue?vue&type=style&index=0&id=4f8eee0e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8eee0e",
  null
  
)

export default component.exports